import { DashboardConfig } from '../../../../common/components/dashboards/types';
import { Languages } from '../../../../constants';
import { getPatagoniaHumanResourcesPageConfigs } from './patagonia_human_resources_page_configs';

const dashboardId = 'patagonia_human_resources';
export const PatagoniaHumanResourcesDashboardConfig: DashboardConfig = {
  id: dashboardId,
  title: {
    [Languages.EN]: 'Patagonia Human Resources (2025-03-31)',
    [Languages.JA]: '人材諸表 (2025-03-31)',
  },
  enabled: true,
  pages: getPatagoniaHumanResourcesPageConfigs(dashboardId),
};
